import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, fmtErr } from "@/lib/api";

const TOGGLES = [
  ["booking_enabled", "Session booking", "Allow visitors to register for group sessions."],
  ["assessment_enabled", "Public assessment", "Allow visitors to submit the capability assessment."],
  ["maintenance_mode", "Maintenance notice", "Show a platform maintenance notice on the public site."],
];

export default function AdminSettingsTab() {
  const [settings, setSettings] = useState(null);
  const load = async () => {
    try { const { data } = await api.get("/admin/settings"); setSettings(data); }
    catch (e) { toast.error(fmtErr(e)); }
  };
  useEffect(() => { load(); }, []);

  const save = async (key, value) => {
    try {
      await api.patch(`/admin/settings/${key}`, { value });
      setSettings({ ...settings, [key]: value });
      toast.success("Setting saved");
    } catch (e) { toast.error(fmtErr(e)); }
  };

  if (!settings) return <p className="text-zinc-500 text-xs uppercase tracking-[0.25em] animate-pulse">Loading settings…</p>;
  return (
    <div data-testid="admin-settings" className="max-w-4xl space-y-4">
      {TOGGLES.map(([key, title, help]) => (
        <div key={key} className="border border-zinc-800 bg-zinc-950 p-5 flex items-center justify-between gap-4">
          <div>
            <h3 className="font-display uppercase text-3xl">{title}</h3>
            <p className="text-sm text-zinc-500 mt-1">{help}</p>
          </div>
          <button data-testid={`setting-${key}`} onClick={() => save(key, !settings[key])}
            className={`w-16 h-9 border transition-colors relative ${settings[key] ? "border-volt bg-volt" : "border-zinc-700 bg-ink"}`}
            aria-label={`Toggle ${title}`}>
            <span className={`absolute top-1 w-7 h-7 transition-transform ${settings[key] ? "translate-x-8 bg-black" : "translate-x-1 bg-zinc-500"}`} />
          </button>
        </div>
      ))}
      <div className="border border-zinc-800 bg-zinc-950 p-5">
        <h3 className="font-display uppercase text-3xl">Homepage announcement</h3>
        <textarea data-testid="setting-announcement" value={settings.announcement || ""} onChange={(e) => setSettings({ ...settings, announcement: e.target.value })}
          rows={4} placeholder="Optional message shown at the top of the public site"
          className="mt-4 w-full bg-ink border border-zinc-700 px-4 py-3 text-sm focus:border-volt outline-none" />
        <button data-testid="save-announcement" onClick={() => save("announcement", settings.announcement || "")}
          className="mt-4 bg-volt text-black px-5 py-3 text-xs uppercase tracking-[0.14em] font-extrabold hover:bg-white transition-colors">Save announcement</button>
      </div>
    </div>
  );
}
